var _path, _rect, _path2, _rect2, _rect3, _rect4, _rect5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAreaMeasurment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.54297 2.2627L20.758 5.70657V23.0298H4.54301L4.54297 2.2627Z",
    fill: "#EFF258",
    fillOpacity: 0.4,
    stroke: "#555555",
    strokeWidth: 1.0216
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.64062,
    y: 10.3457,
    width: 22.2045,
    height: 7.61246,
    fill: "url(#paint0_linear_502_111382)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.981319 9.82945C1.24075 9.72098 1.49933 9.5178 1.75875 9.5178C9.00915 9.50058 16.2595 9.50058 23.5091 9.5178C23.7685 9.5178 24.0279 9.72098 24.2874 9.82945V17.9222C24.0382 18.0195 23.7889 18.2002 23.5389 18.2011C16.2834 18.2166 9.02786 18.2123 1.77236 18.2175C1.4619 18.2175 1.18886 18.1761 0.980469 17.9222C0.981319 15.2249 0.981319 12.5276 0.981319 9.82945ZM23.3203 10.5079H1.94758V17.2265H3.03548V15.2808H3.98304V17.2291H5.06498V13.6408H6.01339V17.2326H7.09448V15.274H8.04288V17.236H9.13929V13.6442H10.0732V17.2231H11.1526V15.2791H12.0738V17.2308H13.1541V13.6408H14.1042V17.224H15.2227V15.2757H16.1456V17.2334H17.2267V13.6382H18.1768V17.2351H19.2732V15.2722H20.219V17.2265H21.3137V13.6451H22.2604V17.2334H23.3211V10.5079H23.3203Z",
    fill: "#555555"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1367,
    y: 4.39844,
    width: 3.24155,
    height: 3.24155,
    rx: 1.0216,
    fill: "#555555"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.92188,
    y: 0.646484,
    width: 3.24155,
    height: 3.24155,
    rx: 1.0216,
    fill: "#555555"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2.92188,
    y: 21.4141,
    width: 3.24155,
    height: 3.24155,
    rx: 1.0216,
    fill: "#555555"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1367,
    y: 21.4141,
    width: 3.24155,
    height: 3.24155,
    rx: 1.0216,
    fill: "#555555"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_502_111382",
    x1: 12.7429,
    y1: 10.3457,
    x2: 12.7429,
    y2: 17.9582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA6B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34BC93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaMeasurment);
export default __webpack_public_path__ + "static/media/AreaMeasurment.7f89192de4835e586abd493a74e86852.svg";
export { ForwardRef as ReactComponent };